import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "mx-5 py-5 flex gap-2",
  style: {"border-bottom":"1px solid #E2E8F0"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "font-bold" }, "Preview", -1)
const _hoisted_3 = { class: "p-5" }
const _hoisted_4 = { class: "border-bottom-grey-2 pb-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold mb-5" }, "Informasi Trayek", -1)
const _hoisted_6 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-semibold text-grey mb-2" }, "Nama Trayek", -1)
const _hoisted_9 = { class: "text-xl font-normal" }
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-semibold text-grey mb-2" }, "Kode Trayek", -1)
const _hoisted_12 = { class: "text-xl font-normal" }
const _hoisted_13 = { class: "mb-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-semibold text-grey mb-2" }, "Kelas", -1)
const _hoisted_15 = { class: "text-xl font-normal" }
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-semibold text-grey mb-2" }, "Tanggal Berlaku", -1)
const _hoisted_18 = { class: "text-xl font-normal" }
const _hoisted_19 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-semibold text-grey mb-2" }, "RIT", -1)
const _hoisted_21 = { class: "text-xl font-normal" }
const _hoisted_22 = { class: "text-base font-normal" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_25 = {
  key: 1,
  class: "pl-4"
}
const _hoisted_26 = { class: "text-base font-normal text-grey" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-semibold text-grey mb-2" }, "Tol/Non Tol", -1)
const _hoisted_30 = { class: "text-xl font-normal" }
const _hoisted_31 = { class: "pt-5 mb-5 flex items-center justify-between" }
const _hoisted_32 = { class: "text-2xl font-bold" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", null, "- Tidak Ada -", -1)
const _hoisted_35 = { class: "text-left break-words font-bold text-sm" }
const _hoisted_36 = { class: "flex gap-4" }
const _hoisted_37 = { class: "font-bold text-sm mb-1" }
const _hoisted_38 = { class: "text-left break-words font-bold text-sm" }
const _hoisted_39 = { class: "font-normal" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode()
const _hoisted_41 = { class: "text-red" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", null, "- Tidak Ada -", -1)
const _hoisted_43 = { class: "flex items-center justify-end gap-4 mt-5" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary font-bold text-sm" }, "Kembali", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm" }, "Simpan Trayek", -1)

import { getCurrentInstance, onMounted, ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import InlineSvg from 'vue-inline-svg'
import InputText from 'primevue/inputtext'
import RadioButton from 'primevue/radiobutton'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Button from 'primevue/button'
import CardCustom from '@/views/components/card/Custom.vue'
import SelectFetch from '@/views/components/form/SelectAsync.vue'
import { Form, Field } from 'vee-validate'
import { DatePicker } from 'v-calendar'
import * as Yup from 'yup'
import moment from 'moment'
import {
  Icon
} from '@iconify/vue'
import circleFill from '@iconify-icons/akar-icons/circle-fill'
import HjpCofirmModal from '@/views/components/modal/HjpConfirmationModal.vue'
import apiUseCase from '@/usecase/apiUseCase'
import InputIconRight from '@/views/components/form/InputIconRight.vue'
import RowInput from '../components/RowInput.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Preview',
  setup(__props) {

const endpoint = '/management/v1/Trayek'
const module = 'globalSetting'

const store = useStore()
const route = useRoute()
const router = useRouter()
const app = getCurrentInstance()
const icons = ref({
  circle: circleFill
})
const {
  $toast,
  $icon
} = app!.appContext.config.globalProperties
const icon = $icon
const dataForm = ref(store.state.trayek.form)
const globalValue = computed(() => store.getters[`${module}/maxPp`]?.Value)
const isLoading = ref(true)
const dataTableVehicle = ref([]) as any
const dataTableVehicleTemp = ref([]) as any
const showConfirmDialog = ref(false)
const trayekType = ref(null) as any
const showRitDetailId = ref(null) as any
const trayekTypeId = ref('')
const inputSearch = ref('')
const countAllPP = ref(0)
const countAllVehicle = ref(0)
const dataFormBody = ref({
  name: '',
  code: '',
  msClassId: '',
  trayekTypeId: '',
  startDate: '',
  endDate: '',
  MinimumFuelConsumptionLiters: 0,
  EstimatedFuelConsumptionLiters: 0,
  MaximumFuelConsumptionLiters: 0,
  isTol: false,
  trayekRoute: [],
  trayekDetails: []
}) as any

const dummyHeader = ref([
  {
    field: 'nopol',
    headerName: `Nopol (${dataForm.value.step2.data.length})`,
    searchable: true,
    fieldSearch: 'nopol',
    isRender: false
  }
])

const TrayekTypeMainId = '8e072a19-599c-45f0-a337-08dbd378cce6'
const TrayekTypeReserveId = '5854668d-2806-41c2-c282-08dbd5e0716f'
const TrayekTypeTouristId = 'add9ce99-53e6-4068-c283-08dbd5e0716f'
const TrayekTypeAirportId = '971ab31f-207d-4ad5-8670-d9fcb9185475'

const confirmDialog = {
  title: 'Simpan Trayek?',
  subTitle: 'Pastikan data Trayek sudah benar dan sesuai dengan yang Anda inginkan.',
  btnSubmitTitle: 'Simpan Trayek',
  imgContent: require('@/assets/img/modal-confirmation/trayek-add.svg')
}

const countTotalExpense = (array: any) => {
  if (array) {
    // const result = array.reduce((a: any, { Nominal: any }) => a + Nominal)
    const result = array.map((item: any) => item.Nominal).reduce((prev: any, next: any) => prev + next)
    return result
  }
  return 0
}

// const initTableHeader = () => {
//   for (let index = 0; index < globalValue.value; index++) {
//     let counting = 0
//     // dataForm.value.step2.data.forEach((el: any) => {
//     // console.log(dataForm.value.step2.data[index].pps)
//     if (index < dataForm.value.step2.data.length) {
//       dataForm.value.step2.data[index].pps.forEach((x: any) => {
//         if ('pp1' in x) {
//           // console.log('true')
//           if (x.pp1 !== null) {
//             counting += 1
//           }
//         }
//       })
//     }
//     // })
//     const temp = {
//       field: `pp${index + 1}`,
//       headerName: `PP${index + 1} (${counting})`,
//       searchable: true,
//       fieldSearch: `pp${index + 1}`,
//       isRender: false
//     }
//     dummyHeader.value.push(temp)
//     countAllPP.value += counting
//     // console.log('countKey', counting)
//   }
//   console.log('dummyHead', dummyHeader.value)
// }

const initTableHeader = () => {
  if (trayekType.value === 1) {
    dummyHeader.value.push(
      {
        field: 'hullNumber',
        headerName: 'No. Lambung',
        searchable: true,
        fieldSearch: 'hullNumber',
        isRender: false
      },
      {
        field: 'purchasedAt',
        headerName: 'Tahun Pembuatan',
        searchable: true,
        fieldSearch: 'purchasedAt',
        isRender: false
      },
      {
        field: 'type',
        headerName: 'Tipe / Karoseri',
        searchable: true,
        fieldSearch: 'type',
        isRender: false
      }
    )
  } else {
    const countArray = [] as any
    for (let index = 0; index < Number(globalValue.value ?? 0); index++) {
      countArray[index] = 0
    }
    for (let index = 0; index < Number(globalValue.value ?? 0); index++) {
      // dataForm.value.step2.data.forEach((el: any) => {
      // console.log(dataForm.value.step2.data[index].pps)
      if (index < dataForm.value.step2.data.length) {
        dataForm.value.step2.data[index].pps.forEach((x: any, i: any) => {
          if ('pp1' in x) {
            // console.log('true')
            if (x.pp1 !== null) {
              // counting += 1
              countArray[i] += 1
            }
          }
        })
      }

      // })
      // console.log('countKey', counting)
    }
    for (let index = 0; index < Number(globalValue.value ?? 0); index++) {
      const temp = {
        field: `pp${index + 1}`,
        headerName: `PP${index + 1} (${countArray[index]})`,
        searchable: true,
        fieldSearch: `pp${index + 1}`,
        isRender: false
      }
      dummyHeader.value.push(temp)
      countAllPP.value += countArray.reduce((a: any, b: any) => a + b, 0)
    }
  }
}

const mappingTableData = () => {
  // const arrayTemp = [] as any
  // for (let index = 0; index < globalValue.value; index++) {
  //   }
  // console.log('data', dataForm.value.step2.data)
  dataForm.value.step2.data.forEach((el: any, index: any) => {
    const obj = {} as any
    obj.nopol = el.nopol.Nopol
    obj.hullNumber = el.nopol.HullNumber
    obj.purchasedAt = el.nopol.PurchasedAt
    obj.pps = el.pps ?? null
    obj.type = el.nopol.Type
    el.pps.forEach((x: any, i: any) => {
      if ('pp1' in x && x) {
        obj[`pp${i + 1}`] = x.pp1 ?? null
      }
    })
    dataTableVehicle.value.push(obj)
  })
  dataTableVehicleTemp.value = dataTableVehicle.value
  // console.log('datatableVehicle', dataTableVehicle.value)
  isLoading.value = false
}

const setDataFormBody = () => {
  console.log('dataForm', dataForm.value)
  // console.log('submitFromDialog')
  dataFormBody.value.name = dataForm.value.step1.name
  dataFormBody.value.code = dataForm.value.step1.code
  dataFormBody.value.msClassId = dataForm.value.step1.class.Id
  dataFormBody.value.trayekTypeId = trayekTypeId.value
  dataFormBody.value.startDate = moment(dataForm.value.step1.startDate).format('YYYY-MM-DD')
  dataFormBody.value.endDate = moment(dataForm.value.step1.endDate).format('YYYY-MM-DD')
  dataFormBody.value.isTol = dataForm.value.step1.isTol
  dataFormBody.value.MinimumFuelConsumptionLiters = dataForm.value.step1.MinimumFuelConsumptionLiters
  dataFormBody.value.EstimatedFuelConsumptionLiters = dataForm.value.step1.EstimatedFuelConsumptionLiters
  dataFormBody.value.MaximumFuelConsumptionLiters = dataForm.value.step1.MaximumFuelConsumptionLiters

  if (trayekType.value !== 1) {
    dataForm.value.step1.rits.forEach((data: any, index: any) => {
      const obj = {
        id: data.trayekRouteId ?? null,
        name: `RIT ${index + 1}`,
        msRouteId: data.rit.Id,
        ritOrder: index + 1,
        msExpensesId: data.expense ? data.expense.Id : null
      }
      dataFormBody.value.trayekRoute.push(obj)
    })
  }

  dataForm.value.step2.data.forEach((data: any, index: any) => {
    const objSubs = {
      id: data.trayekDetailId ?? null,
      msVehicleId: data.nopol.Id,
      regNumber: data.nopol.Nopol,
      trayekSubs: [] as any
    }
    // if (trayekType.value !== 1 && trayekType.value !== 0) {
    if (trayekType.value !== 1) { // trayek utama dan bandara disamakan
      data.pps.forEach((x: any, i: any) => {
        const detailsTemp = [] as any
        x.details.forEach((d: any, idx: any) => {
          // console.log('d', d)
          if (d.departure && d.arrival) {
            d.detailTerminals.forEach((terminal: any) => {
              const objSubsDetailRit = {
                id: terminal.id ?? null,
                ritOrder: idx + 1,
                ritArrivalTime: terminal.arrival ? `${terminal.arrival}:00` : null,
                ritDepartureTime: terminal.departure ? `${terminal.departure}:00` : null,
                dayOffset: terminal.dayOffset ?? 0,
                msRouteId: d.routeId,
                // isCrossDay: terminal.isCrossDay,
                trayekSubId: x.id,
                msRouteDetailId: terminal.routeDetailId
              }
              detailsTemp.push(objSubsDetailRit)
            })
          }
        })
        if (x.departure && x.arrival) {
          const objSubsDetail = {
            id: x.id ?? null,
            order: i + 1,
            arrivalTime: x.arrival ? `${x.arrival}:00` : null,
            departureTime: x.departure ? `${x.departure}:00` : null,
            // isCrossDay: x.isCrossDay,
            trayekSubsDetails: detailsTemp
          }
          objSubs.trayekSubs.push(objSubsDetail)
        }
      })
    }
    // } else if (trayekType.value === 0) {
    //   data.pps.forEach((x: any, i: any) => {
    //     const detailsTemp = [] as any
    //     if (x.departure && x.arrival) {
    //       const objSubsDetail = {
    //         id: x.id ?? null,
    //         order: i + 1,
    //         arrivalTime: x.arrival ? `${x.arrival}:00` : null,
    //         departureTime: x.departure ? `${x.departure}:00` : null,
    //         isCrossDay: x.isCrossDay,
    //         trayekSubsDetails: detailsTemp
    //       }
    //       objSubs.trayekSubs.push(objSubsDetail)
    //     }
    //   })
    // }
    dataFormBody.value.trayekDetails.push(objSubs)
  })
  // console.log('submitFromDialog', dataFormBody.value)
}

const hideDialogConfirmation = () => {
  // console.log('hideDialog')
  showConfirmDialog.value = false
  dataFormBody.value = {
    name: '',
    code: '',
    msClassId: '',
    trayekTypeId: '',
    startDate: '',
    endDate: '',
    MinimumFuelConsumptionLiters: 0,
    EstimatedFuelConsumptionLiters: 0,
    MaximumFuelConsumptionLiters: 0,
    isTol: false,
    trayekRoute: [],
    trayekDetails: []
  }
}

const prevPage = () => {
  hideDialogConfirmation()
  store.dispatch('setTrayekFormStep', store.state.trayek.formStep - 1)
  // console.log('formStep', store.state.trayek.formStep)
}

const showDialogConfirmation = () => {
  // console.log('showDialog')
  setDataFormBody()
  showConfirmDialog.value = true
}

const backToListPage = () => {
  const temp = route.path.split('/')
  router.push({
    name: temp[2]
  })
}

const submitFromDialog = () => {
  // console.log('dataFormBody', dataFormBody.value)
  apiUseCase.postOrPut(endpoint, route.params.id, dataFormBody.value)
    .then(({ error, message }) => {
      if (!error) {
        hideDialogConfirmation()
        store.dispatch('setReloadDataList', true)
        store.dispatch('setShowModalFormDl', false)
        backToListPage()
        $toast.add({
          severity: 'success',
          summary: 'Berhasil',
          detail: 'Trayek berhasil disimpan.',
          group: 'bc',
          closable: false,
          life: 3000
        })
      } else {
        store.dispatch('setShowModalFormDl', false)
        $toast.add({
          severity: 'error',
          summary: 'Gagal',
          detail: message,
          group: 'bc',
          closable: false,
          life: 3000
        })
      }
      store.dispatch('hideLoading')
    })
  // store.dispatch('hideLoading')
}

const showRitDetail = (val: any) => {
  showRitDetailId.value = val
}

const onSearch = () => {
  dataTableVehicle.value = dataTableVehicleTemp.value
  if (inputSearch.value !== '') {
    dataTableVehicle.value = dataTableVehicle.value.filter((x: any) => x.nopol.toLowerCase().includes(inputSearch.value.toLowerCase()))
    // console.log('data', dataTableVehicle.value)
  }
}

onMounted(() => {
  if (route.path.includes('reserve')) {
    trayekType.value = 1
    trayekTypeId.value = TrayekTypeReserveId
  } else if (route.path.includes('tourist')) {
    trayekType.value = 1
    trayekTypeId.value = TrayekTypeTouristId
  } else if (route.path.includes('airport')) {
    trayekType.value = 2
    trayekTypeId.value = TrayekTypeAirportId
  } else {
    trayekType.value = 0
    trayekTypeId.value = TrayekTypeMainId
  }
  initTableHeader()
  mappingTableData()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CardCustom, null, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(InlineSvg), {
            src: require('@/assets/img/icon/stack-with-box.svg')
          }, null, 8, ["src"]),
          _hoisted_2
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, _toDisplayString(dataForm.value.step1.name), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, _toDisplayString(dataForm.value.step1.code), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, _toDisplayString(dataForm.value.step1.class?.Name), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, _toDisplayString(`${_unref(moment)(dataForm.value.step1.startDate.toString()).format('DD MMMM YYYY')} - ${_unref(moment)(dataForm.value.step1.endDate.toString()).format('DD MMMM YYYY')}`), 1)
              ]),
              (_unref(trayekType) !== 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _hoisted_20,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataForm.value.step1.rits, (data, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: ""
                      }, [
                        _createElementVNode("div", _hoisted_21, _toDisplayString(`${index+1}. ${data.rit?.Name}`), 1),
                        _createElementVNode("div", _hoisted_22, _toDisplayString(`Biaya ${data.rit?.Code} (Rp. ${data.expense ? countTotalExpense(data.expense?.Details) : '0'})`), 1),
                        (_unref(showRitDetailId) === index)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              (!data.expense)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, "- Tidak Ada Pengeluaran -"))
                                : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.expense?.Details, (item, i) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: i,
                                        class: "flex items-center gap-2"
                                      }, [
                                        _createVNode(_unref(Icon), {
                                          icon: icons.value.circle,
                                          class: "circle-icon",
                                          style: {"color":"#67748e","fill":"#67748e"},
                                          height: '7px',
                                          width: '7px'
                                        }, null, 8, ["icon"]),
                                        _createElementVNode("div", _hoisted_26, _toDisplayString(`${item.Type ?? item.MsExpensesType.Name} (${item.Nominal})`), 1)
                                      ]))
                                    }), 128))
                                  ]))
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(showRitDetailId) !== index)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              onClick: ($event: any) => (showRitDetail(index)),
                              class: "text-sm text-primary cursor-pointer"
                            }, "Lebih Banyak", 8, _hoisted_27))
                          : _createCommentVNode("", true),
                        (_unref(showRitDetailId) === index)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (showRitDetail(null))),
                              class: "text-sm text-primary cursor-pointer"
                            }, "Lebih Sedikit"))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_unref(trayekType) !== 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, _toDisplayString(dataForm.value.step1.isTol ? 'Tol' : 'Non Tol'), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, "Daftar (" + _toDisplayString(_unref(dataTableVehicleTemp).length) + ") Bus dan (" + _toDisplayString(countAllPP.value) + ") PP", 1),
            _createElementVNode("div", null, [
              _createVNode(InputIconRight, {
                class: "input-search-header-custom",
                placeholder: "Cari Bus",
                modelValue: inputSearch.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputSearch).value = $event)),
                canClick: true,
                icon: _unref(icon).svg.searchEva,
                onSubmitInput: onSearch,
                onKeyup: _withKeys(onSearch, ["enter"])
              }, null, 8, ["modelValue", "icon", "onKeyup"])
            ])
          ]),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                (_unref(trayekType) !== 1)
                  ? (_openBlock(), _createBlock(_unref(DataTable), {
                      key: 0,
                      value: _unref(dataTableVehicle),
                      paginator: "",
                      rows: 5,
                      rowsPerPageOptions: [5, 10, 20, 50],
                      scrollable: ""
                    }, {
                      empty: _withCtx(() => [
                        _hoisted_34
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(Column), {
                          header: "Nopol",
                          style: {"width":"100px"}
                        }, {
                          body: _withCtx(({ data }) => [
                            _createElementVNode("p", _hoisted_35, _toDisplayString(data.nopol), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(Column), {
                          header: "Rit",
                          style: {"min-width":"200px"}
                        }, {
                          body: _withCtx(({ data }) => [
                            _createElementVNode("div", _hoisted_36, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.pps, (items, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: items }, [
                                  _createElementVNode("p", _hoisted_37, _toDisplayString(`PP${index + 1}`), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.details, (item, indexDetail) => {
                                    return (_openBlock(), _createElementBlock("div", { key: item }, [
                                      _createElementVNode("p", _hoisted_38, [
                                        _createTextVNode(_toDisplayString(`Rit ${indexDetail + 1}`) + " ", 1),
                                        _createElementVNode("span", _hoisted_39, _toDisplayString(`(${item.departure ?? 'kosong'} - ${item.arrival ?? 'kosong'})`), 1),
                                        _hoisted_40,
                                        _createElementVNode("span", _hoisted_41, _toDisplayString(`${item.isCrossDay ? '(Lintas Hari)' : ''}`), 1)
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"]))
                  : (_openBlock(), _createBlock(_unref(DataTable), {
                      key: 1,
                      value: _unref(dataTableVehicle),
                      paginator: "",
                      rows: 5,
                      rowsPerPageOptions: [5, 10, 20, 50],
                      scrollable: ""
                    }, {
                      empty: _withCtx(() => [
                        _hoisted_42
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dummyHeader.value, (col) => {
                          return (_openBlock(), _createBlock(_unref(Column), {
                            sortable: "",
                            key: col.field,
                            field: col.field,
                            header: col.headerName,
                            frozen: col.field === 'nopol',
                            style: _normalizeStyle(col.field === 'nopol' ? 'min-width: 150px;' : 'min-width: 100px;')
                          }, null, 8, ["field", "header", "frozen", "style"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"]))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_43, [
      _createVNode(_unref(Button), {
        class: "flex gap-2 extra-submit-button",
        outlined: true,
        onClick: prevPage
      }, {
        default: _withCtx(() => [
          _hoisted_44
        ]),
        _: 1
      }),
      _createVNode(_unref(Button), {
        class: "mb-2 sm:mb-0 flex gap-2",
        onClick: showDialogConfirmation
      }, {
        default: _withCtx(() => [
          _hoisted_45
        ]),
        _: 1
      })
    ]),
    _createVNode(HjpCofirmModal, {
      show: showConfirmDialog.value,
      title: confirmDialog?.title,
      subTitle: confirmDialog?.subTitle,
      btnSubmitTitle: confirmDialog?.btnSubmitTitle,
      imgContent: confirmDialog.imgContent,
      onHideDialog: hideDialogConfirmation,
      onOnSubmit: submitFromDialog
    }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle", "imgContent"])
  ]))
}
}

})